// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';
import { IconHome } from '@tabler/icons-react';

const accueil = {
    id: 'accueil',
    title: <FormattedMessage id="accueil" />,
    icon: IconHome,
    type: 'group',
    url: '/ui/accueil'
};

export default accueil;
